module.exports = __webpack_public_path__ + "static/media/benefit-cosmetics.661df19b.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/brand-logos/benefit-cosmetics.png
// module id = 76
// module chunks = 0